<template>
<div id="CourseSideBar">
  <Tabs ref="tabs" v-model="tabValue">
    <TabPane label="视频" name="video">
      <CourseVideos :course="course" :videos="videos" v-if="tabValue === 'video'"></CourseVideos>
    </TabPane>
  </Tabs>
</div>
</template>

<script>
import CourseInfo from './CourseInfo'
import CourseVideos from './CourseVideos'

export default {
  components: {
    CourseInfo,
    CourseVideos,
  },
  props: {
    course: {
      type: Object,
    },
    videos: {
      type: Array,
      default () {
        return []
      },
    },
  },
  data () {
    return {
      tabValue: 'video',
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/sidebar.scss';
</style>
